import { create } from 'zustand';
import { ReactNode } from 'react';

type ModalState = {
  isOpen: boolean;
  content: ReactNode | null;
  openModal: <T>(content: ReactNode) => Promise<T | null>;
  closeModal: <T>(result: T) => void;
};

let resolveRef: (() => void) | null = null;
let typedResolve: (<T>(value: T) => void) | null = null;

const useModalStore = create<ModalState>((set) => ({
  isOpen: false,
  content: null,

  openModal: <T>(content: ReactNode): Promise<T> =>
    new Promise<T>((resolve) => {
      typedResolve = resolve as (value: unknown) => void;
      resolveRef = () => {
        set({ isOpen: false, content: null });
        typedResolve = null;
      };
      set({ isOpen: true, content });
    }),

  closeModal: <T>(result: T) => {
    if (typedResolve) {
      typedResolve(result);
    }
    resolveRef?.();
    resolveRef = null;
  },
}));

export default useModalStore;
